module.exports = __webpack_public_path__ + "img/icon-blogroll1.1403a904.png";